import { create } from 'zustand';

/**
 * Lightweight, continuously-updated snapshot of "what's going on right now" —
 * pushed by PocketParliamentarianApp so the top-level ReportIssueButton (which
 * lives outside that component's state tree) can attach useful context to a
 * bug/feature report without needing meeting state threaded down to it.
 */
export const useReportContextStore = create((set) => ({
  screenName: null,
  organizationName: null,
  parliamentaryMode: null,
  sessionMode: null,
  quorumRequirement: null,
  quorumType: null,
  inMeeting: false,
  inElection: false,

  setReportContext: (partial) => set(partial),

  reset: () =>
    set({
      screenName: null,
      organizationName: null,
      parliamentaryMode: null,
      sessionMode: null,
      quorumRequirement: null,
      quorumType: null,
      inMeeting: false,
      inElection: false,
    }),
}));
